import initMap from './modules/map';

document.addEventListener('DOMContentLoaded', function () {
  initMap();
});
